import { stat } from "fs";

const repayindexSearch = {
  state: {
    data: null
  },
  mutations: {
    SET_REPAYINDEXSEARCH: (state, repayindexSearch) => {
      state.data = repayindexSearch
    }
  }
}

export default repayindexSearch



// WEBPACK FOOTER //
// ./src/store/modules/repayindexSearch.js